// extracted by mini-css-extract-plugin
export default {"loadingButton":"routerPrompt_loadingButton__H-mq4"};